import { gql } from "lib/apolloClient";
import { standardsFragment, benchmarksFragment } from "./Fragments";

export const getAdminStandardsQuery = gql`
  query getAdminStandards($id: ID!, $filters: PlannerElementNodeFilters) {
    node(id: $id, type: PLANNER_ELEMENT_NODE_SET) {
      ... on PlannerElementNodeSet {
        id
        plannerElementNodeSetWrapperV2 {
          ... on PlannerElementNodeSetWrapper {
            publishedData(filters: $filters) {
              edges {
                node {
                  ...standardsFragment
                }
              }
            }
          }
          ... on PlannerBenchmarkSetWrapper {
            publishedData(filters: $filters) {
              edges {
                node {
                  ...benchmarksFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${standardsFragment}
  ${benchmarksFragment}
`;
